import React, { useContext } from 'react';
import { CartContext } from 'components/cart';
import PropTypes from 'prop-types';
import classNames from 'lib/classNames';

const EmptyState = () => {
	const { cart_settings } = useContext(CartContext);
	return (
		<div className={classNames('relative p-3 empty-cart w-full min-w-full max-w-full')}>
			<div dangerouslySetInnerHTML={{ __html: cart_settings.empty_cart }}></div>
		</div>
	);
};

EmptyState.propTypes = {};

export default EmptyState;
